document.addEventListener("DOMContentLoaded", function () {
  const viewMoreBtn = document.querySelector(".view-more");
  const viewLessBtn = document.querySelector(".view-less");
  const galleryItems = document.querySelectorAll(".gallery-item");
  const popup = document.querySelector(".image-popup");
  const popupImage = document.querySelector(".popup-image");
  const closePopup = document.querySelector(".close-popup");

  if (!galleryItems.length) return;

  /* -------------------------------
     IMAGE POPUP (UNCHANGED)
  -------------------------------- */
  galleryItems.forEach((item) => {
    item.addEventListener("click", function () {
      const img = this.querySelector("img");
      if (!img) return;
      popupImage.src = img.src;
      popup.classList.add("active");
    });
  });

  closePopup.addEventListener("click", function () {
    popup.classList.remove("active");
  });

  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.remove("active");
    }
  });

  /* -------------------------------
     VIEW MORE / VIEW LESS (STEP = 9)
  -------------------------------- */
  const STEP = 9;
  let visibleCount = STEP;

  function updateGallery() {
    galleryItems.forEach((item, index) => {
      if (index < visibleCount) {
        item.classList.remove("hidden-image");
      } else {
        item.classList.add("hidden-image");
      }
    });

    // Toggle buttons
    if (visibleCount >= galleryItems.length) {
      viewMoreBtn.classList.add("hidden");
      viewLessBtn.classList.remove("hidden");
    } else {
      viewMoreBtn.classList.remove("hidden");
      viewLessBtn.classList.add("hidden");
    }
  }

  // Initial state
  updateGallery();

  // View More → show next 9
  viewMoreBtn.addEventListener("click", function () {
    visibleCount += STEP;
    updateGallery();
  });

  // View Less → reset to 9
  viewLessBtn.addEventListener("click", function () {
    visibleCount = STEP;
    updateGallery();

    document
      .querySelector(".gallery-container")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});
